import axios from 'axios';
import { FishGroup } from '../features/view-fish-group/types/fish-group.type';

// GET
// /ewosapi/v1/planandprognosis/site/{globalSiteId}/fishgroup
export const getFishGroups = async (globalSiteId: string): Promise<FishGroup[]> => {
  const res = await axios.get<FishGroup[]>(`/ewosapi/v1/planandprognosis/site/${globalSiteId}/fishgroup`);
  return res.data;
};
